import * as React from 'react';

function SvgIconPaymentWebsiteDisable(props) {
  return (
    <svg viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#EBEBEB" cx={28} cy={28} r={28} />
        <g fill="#C8C9CB">
          <path d="M28 40c-6.616 0-12-5.385-12-12s5.384-12 12-12 12 5.385 12 12-5.384 12-12 12zm0-22.69c-5.894 0-10.69 4.795-10.69 10.69S22.106 38.69 28 38.69c5.894 0 10.69-4.795 10.69-10.69S33.894 17.31 28 17.31z" />
          <path d="M28 40c-3.397 0-6-5.28-6-12s2.603-12 6-12 6 5.28 6 12c0 6.685-2.636 12-6 12zm0-22.69c-2.541 0-4.727 4.874-4.727 10.69S25.459 38.69 28 38.69c2.541 0 4.727-4.874 4.727-10.69 0-5.778-2.218-10.69-4.727-10.69z" />
          <path d="M19.327 21.252c-.31-.188-.421-.566-.24-.873.186-.313.56-.426.86-.245a16.664 16.664 0 008.03 2.065c2.85 0 5.606-.72 8.072-2.11.304-.185.678-.071.864.242.182.306.07.685-.243.874a17.545 17.545 0 01-8.694 2.295 17.98 17.98 0 01-8.649-2.248zM19.651 36a.654.654 0 01-.562-.322c-.185-.317-.071-.708.25-.906C22.022 33.293 25.026 32.5 28 32.5c3.02 0 6.02.766 8.667 2.226.316.194.43.585.245.902-.19.324-.57.441-.875.254A16.317 16.317 0 0028 33.795c-2.779 0-5.59.731-8.026 2.024-.072.148-.152.181-.323.181zm19.694-7.25h-22.69c-.386 0-.655-.308-.655-.75s.269-.75.655-.75h22.69c.386 0 .655.308.655.75 0 .425-.304.75-.655.75z" />
        </g>
      </g>
    </svg>
  );
}

export default SvgIconPaymentWebsiteDisable;
